import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Spinner } from "@/components/common";
import { timeAgo } from "@/lib/ui";

export default function AuditLog() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit?limit=300").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="p-6"><Spinner /></div>;
  return (
    <div className="p-6 fade-up">
      <PageHeader title="Audit Log" subtitle={`${rows.length} recent events · append-only, attributable`} testid="audit-page" />
      <div className="card-surface rounded-lg overflow-hidden">
        <table className="w-full text-left text-[13px]" data-testid="audit-table">
          <thead><tr className="text-[10px] uppercase tracking-wider text-slate-500 bg-slate-900/80 border-b border-slate-800">
            <th className="px-3 py-2">Time</th><th className="px-3 py-2">Actor</th><th className="px-3 py-2">Action</th><th className="px-3 py-2">Object</th><th className="px-3 py-2">Result</th><th className="px-3 py-2">Source IP</th></tr></thead>
          <tbody className="divide-y divide-slate-800/60">
            {rows.map((a) => (
              <tr key={a.id} className="hover-row">
                <td className="px-3 py-1.5 text-slate-500">{timeAgo(a.timestamp)}</td>
                <td className="px-3 py-1.5 text-slate-300">{a.actor}</td>
                <td className="px-3 py-1.5 font-mono text-cyan-300">{a.action}</td>
                <td className="px-3 py-1.5 text-slate-400 font-mono">{a.object_type}</td>
                <td className="px-3 py-1.5">{a.result === "success" ? <span className="text-emerald-400">success</span> : <span className="text-rose-400">{a.result}</span>}</td>
                <td className="px-3 py-1.5 text-slate-500 font-mono">{a.source_ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
